import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { IssueLinkType } from '@atlassian/jira-issue-shared-types/src/common/types/linked-issue-type.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { InvokedFrom, ResourceSuggestion } from '../../controllers/context.tsx';
import { LinkSplitButton } from '../link-split-button/index.tsx';

type FooterProps = {
	suggestions: ResourceSuggestion[] | undefined;
	onAcceptAllSuggestions: () => void;
	onAcceptSelectedSuggestions: (issueLinkType: IssueLinkType) => void;
	invokedFrom: InvokedFrom;
	relatesToIssueLinkType: IssueLinkType | undefined;
	issueLinkTypes: IssueLinkType[];
	hasSelectedSuggestions: boolean;
};

export const Footer: React.FC<FooterProps> = ({
	suggestions,
	onAcceptSelectedSuggestions,
	invokedFrom,
	hasSelectedSuggestions,
}) => {
	if (!suggestions || suggestions.length === 0) {
		return null;
	}

	// We don't show a CTA button in GIC
	if (
		invokedFrom === 'globalIssueCreate' &&
		expVal('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)
	) {
		return null;
	}

	return (
		<LinkSplitButton
			onButtonClick={onAcceptSelectedSuggestions}
			isButtonDisabled={!hasSelectedSuggestions}
			appearance={fg('jira-ai-suggested-works-ui-update') ? 'default' : 'primary'}
		/>
	);
};
